import * as types from './constants';

// Get Merchant By Id
export const getMerchantByIdRequest = data => (
  { type: types.GET_MERCHANT_BY_ID_REQUEST, payload: data }
);

export const getMerchantByIdDone = data => (
  { type: types.GET_MERCHANT_BY_ID_DONE, payload: data }
);

export const getMerchantByIdFailed = () => (
  { type: types.GET_MERCHANT_BY_ID_FAILED }
);

// Edit Merchant
export const editMerchantRequest = data => (
  { type: types.EDIT_MERCHANT_REQUEST, payload: data }
);

export const editMerchantDone = data => (
  { type: types.EDIT_MERCHANT_DONE, payload: data }
);

export const editMerchantFailed = errors => (
  { type: types.EDIT_MERCHANT_FAILED, payload: errors }
);